"use client";

import Image from "next/image";
import React, { useEffect, useState } from "react";

interface PageHeroProps {
    title: string;
    subtitle?: string;
    backgroundImage: string;
    mobileBackgroundImage?: string;
}

export default function PageHero({
    title,
    subtitle,
    backgroundImage,
    mobileBackgroundImage,
}: PageHeroProps) {
    const [heroBannerImageSrc, setHeroBannerImageSrc] = useState(backgroundImage);

    useEffect(() => {
        const updateImage = () => {
            let newSrc = mobileBackgroundImage || backgroundImage;

            if (window.innerWidth >= 992) {
                newSrc = backgroundImage;
            } else if (window.innerWidth >= 576) {
                newSrc = backgroundImage;
            }

            setHeroBannerImageSrc(newSrc);
        };

        updateImage(); // Set initial image
        window.addEventListener("resize", updateImage);

        return () => window.removeEventListener("resize", updateImage);
    }, [backgroundImage, mobileBackgroundImage]);

    return (
        <div>
            <div className="w-full sm:max-w-[90.80vw] lg:max-w-[89.58vw] min-h-[75vh] sm:min-h-fit lg:min-h-[75vh]  mx-auto relative">
                <div>
                    <Image
                        src={heroBannerImageSrc}
                        alt={`${title} banner`}
                        priority
                        fill
                        className="!static"
                    />
                </div>
                <div className="absolute bg-PrimaryLightBlue text-center sm:text-left bottom-10 sm:bottom-auto sm:top-[50%] lg:top-[16vw] right-1/2 translate-x-1/2 sm:right-0 sm:translate-x-0 sm:translate-y-[-50%] w-[90.69vw] sm:w-[55%] lg:w-[35%] py-mob-40 sm:px-tab-35 sm:py-tab-20 lg:px-web-40 lg:py-web-25 rounded-lg  sm:rounded-tr-none  sm:rounded-br-none">
                    <h2 className="relative z-[5] text-mob-40 sm:text-tab-40 lg:text-web-50 leading-[120%] text-SecondaryYellow font-normal drop-shadow-sm  mb-mob-8 sm:mb-tab-8 lg:mb-web-6">
                        {title}
                    </h2>
                    {subtitle && (
                        <p className=" text-mob-24 sm:text-tab-24 lg:text-web-28 leading-[130%] text-white">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}
